import React from "react";
import { Card, Col, ProgressBar, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useRouteLoaderData } from "react-router-dom";

import { useAppContext } from "@/App";
import { DeveloperFinanceModeration, GamePublicationState } from "@/const";
import { GamePublicationStateProgressBar, GamePublicationWishlistStateProgressBar } from "@components/Game/Misc";
import { DeveloperMenu } from "@components/NaviDeveloper";
import { GameMenu } from "@components/NaviGame";

function PageSpinner() {
    return (
        <Card>
            <Card.Body>
                <div className="d-flex align-items-center justify-content-center">
                    <Spinner animation="border" variant="primary" role="status" />
                </div>
            </Card.Body>
        </Card>
    );
}

export function DefaultLayout({ children, width }) {
    const { apiIsLoading } = useAppContext();
    let className = "";
    if (width === 75 || width === 50) {
        className = `w-${width} mx-auto`;
    }
    return (
        <Row className="flex-xl-nowrap">
            <Col>
                <div className={className}>
                    {apiIsLoading === true && <PageSpinner />}
                    {children}
                </div>
            </Col>
        </Row>
    );
}

export function GameLayout({ body, active }) {
    const { apiIsLoading } = useAppContext();
    const gameCommonInfo = useRouteLoaderData("gameCommonInfo");

    return (
        <>
            {gameCommonInfo.game.publication_state !== GamePublicationState.DONE && (
                <>
                    <GamePublicationStateProgressBar />
                    {(gameCommonInfo.game.is_main_client || gameCommonInfo.game.dlc) && (
                        <GamePublicationWishlistStateProgressBar />
                    )}
                </>
            )}
            <Row>
                <Col md={3}>
                    <GameMenu active={active} />
                </Col>
                <Col md={9}>
                    {apiIsLoading === true && <PageSpinner />}
                    {body}
                </Col>
            </Row>
        </>
    );
}

export function DeveloperLayout({ body, active }) {
    const { t } = useTranslation();
    const { apiIsLoading } = useAppContext();
    const developerCommonInfo = useRouteLoaderData("developerCommonInfo");
    if (developerCommonInfo.status === "fail") {
        return;
    }

    const { finance_moderation } = developerCommonInfo.developer;
    const progressbar = [{ label: t("Конфигурация") }, { label: t("Финансовая модерация") }, { label: t("Пройдена") }];
    if ([DeveloperFinanceModeration.NEW, DeveloperFinanceModeration.REJECTED].includes(finance_moderation)) {
        progressbar[0].variant = "warning";
    } else if (finance_moderation === DeveloperFinanceModeration.ON_MODERATION) {
        progressbar[0].variant = "success";
        progressbar[1].variant = "warning";
    } else {
        progressbar[0].variant = "success";
        progressbar[1].variant = "success";
        progressbar[2].variant = "success";
    }

    return (
        <>
            {finance_moderation !== DeveloperFinanceModeration.APPROVED && (
                <Row>
                    <Col md={12}>
                        <ProgressBar className="my-3">
                            {progressbar.map((state, i) => {
                                return (
                                    <ProgressBar
                                        key={`progressbar${i}`}
                                        striped
                                        variant={state.variant || "secondary"}
                                        now="33.33"
                                        label={state.label}
                                        className={state.variant === "warning" ? "text-dark" : ""}
                                    />
                                );
                            })}
                        </ProgressBar>
                    </Col>
                </Row>
            )}
            <Row>
                <Col md={3}>
                    <DeveloperMenu active={active} />
                </Col>
                <Col md={9}>
                    {apiIsLoading === true && <PageSpinner />}
                    {body}
                </Col>
            </Row>
        </>
    );
}
